module.exports = __webpack_public_path__ + "static/img/1-1.8ad01e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/1-1.png
// module id = A66P
// module chunks = 0